<template>
  <div>
    <v-card width="100%" v-if="current">
      <v-card-title>Dados do registro</v-card-title>
      <v-card-text>
        <v-form>
          <div class="row">
            <div class="col-md-4 col-sm-1">
              <v-autocomplete
                label="Cliente"
                v-model="current.clientId"
                :search-input.sync="searchClient"
                :items="clients"
                item-text="name"
                item-value="id"
                outlined
                dense
              ></v-autocomplete>
            </div>
            <div class="col-md-4 col-sm-1">
              <v-autocomplete
                label="Plano"
                v-model="current.planId"
                :search-input.sync="searchPlan"
                :items="plans"
                item-text="name"
                item-value="id"
                outlined
                dense
              ></v-autocomplete>
            </div>
            <div class="col-md-4 col-sm-1">
              <v-select
                label="Status"
                v-model="current.status"
                :items="status"
                item-text="name"
                item-value="id"
                outlined
                dense
              ></v-select>
            </div>
            <div class="col-md-9 col-sm-1">
              <v-text-field
                label="Contato"
                v-model="current.contact"
                outlined
                dense
              ></v-text-field>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-text-field
                label="Telefone"
                v-model="current.phone"
                outlined
                dense
              ></v-text-field>
            </div>
            <div class="col-md-12 col-sm-1">
              <v-sheet elevation="1" class="pa-2">
                Tags:
                <v-chip
                  v-for="item in tags"
                  :key="item.name"
                  close
                  @click:close="removeTag(item.name)"
                  class="ma-2"
                >
                  {{ item.name }}
                </v-chip>
                <v-chip @click="addTag()">+</v-chip>
              </v-sheet>
            </div>
          </div>

          <v-tabs v-model="tab" grow class="mt-2">
            <v-tab key="drop"> Drop </v-tab>
            <v-tab key="dados"> Dados </v-tab>
            <v-tab key="financeiro"> Financeiro </v-tab>
            <v-tab key="suporte"> Suporte </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item key="drop">
              <v-card flat>
                <v-card-text>
                  <div class="row">
                    <div class="col-md-6 col-sm-1">
                      <v-text-field
                        label="Logradouro"
                        v-model="current.address"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-2 col-sm-1">
                      <v-text-field
                        label="Número"
                        v-model="current.addressNumber"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-2 col-sm-1">
                      <v-text-field
                        label="Complemento"
                        v-model="current.addressExtra"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-2 col-sm-1">
                      <v-text-field
                        label="Bairro"
                        v-model="current.addressNeighborhood"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="Cidade"
                        v-model="current.city"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="Estado"
                        v-model="current.province"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="País"
                        v-model="current.country"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="CEP"
                        v-model="current.zipcode"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item key="dados">
              <v-card flat>
                <v-card-text>
                  <div class="row">
                    <div class="col-md-6 col-sm-1">
                      <v-text-field
                        label="Serial"
                        v-model="current.serial"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-6 col-sm-1">
                      <v-select
                        label="NMS"
                        v-model="current.nms"
                        :items="nms"
                        item-text="name"
                        item-value="id"
                        outlined
                        dense
                      ></v-select>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item key="financeiro">
              <v-card flat>
                <v-card-text>
                  <div class="row">
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="Mensalidade"
                        v-model="current.price"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="Vencimento"
                        v-model="current.expires"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-2 col-sm-1">
                      <v-text-field
                        label="Taxa de Instalação"
                        v-model="current.setupPrice"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-2 col-sm-1">
                      <v-text-field
                        label="Parcelas da Instalação"
                        v-model="current.setupSplit"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="col-md-2 col-sm-1">
                      <v-menu
                        v-model="menu_setup"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="computedSetup"
                            label="Dia da Instalação"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            outlined
                            dense
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="current.setup"
                          @input="setupAlterada()"
                          locale="pt-br"
                        ></v-date-picker>
                      </v-menu>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item key="suporte">
              <v-card flat>
                <v-card-text>
                  <div class="row">
                    <div class="col-md-12 col-sm-1">
                      <v-textarea
                        label="Observações"
                        v-model="current.obs"
                        outlined
                        dense
                      ></v-textarea>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div>
          <v-btn color="success" @click="save()">Salvar</v-btn>
        </div>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="dialog_loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Por favor aguarde
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "../../api/index.js";
import router from "../../router/index.js";
export default {
  data: () => ({
    current: null,
    tab: null,
    menu_setup: false,
    clients: [],
    searchClient: null,
    plans: [],
    searchPlan: null,
    nms: [],
    status: [
      { id: 0, name: "Habilitado" },
      { id: 1, name: "Bloqueado administrador" },
      { id: 2, name: "Bloqueado cliente" },
      { id: 3, name: "Bloqueado pagamento" },
      { id: 4, name: "Cancelado" },
    ],
    dialog_loading: false,
  }),
  created: function () {
    this.load();
    this.loadNMS();
  },
  methods: {
    loadNMS: function(){
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/nms", {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.nms = response.data;
        })
        .catch(function (error) {
          alert("Falha ao recuperar NMS!");
          console.log(error);
        });
    },
    load: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .get("/lastmile/0", {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao gerar formulario de cadastro!");
          console.log(error);
        });
    },
    save: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .post("/lastmile", this.current, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function () {
          me.dialog_loading = false;
          alert("Lastmile cadastrada com sucesso!");
          router.push({ path: "/lastmile" });
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao salvar formulario de cadastro!");
          console.log(error);
        });
    },
    formatDate: function (date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    setupAlterada: function () {
      this.menu_setup = false;
    },
    removeTag: function (tag) {
      var ntags = "";
      var tgs = this.current.tags.split(" ");
      for (var i = 0; i < tgs.length; i++) {
        if (tgs[i] != tag) {
          ntags += tgs[i] + " ";
        }
      }
      this.current.tags = ntags.trim();
    },
    addTag: function () {
      var tg = prompt("Digite a tag: ");
      if (tg) {
        this.current.tags = this.current.tags + " " + tg;
      }
    },
  },
  computed: {
    computedSetup: function () {
      return this.formatDate(this.current.setup);
    },
    tags: function () {
      var ret = [];
      var tgs = this.current.tags.split(" ");
      for (var i = 0; i < tgs.length; i++) {
        if (tgs[i] != "") {
          ret.push({ name: tgs[i] });
        }
      }
      return ret;
    },
  },
  watch: {
    searchClient: function (val) {
      var me = this;
      if (val.length != 3) return;
      var token = localStorage.getItem("token");
      api
        .get("/client/name/" + val, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.clients = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    searchPlan: function (val) {
      var me = this;
      if (val.length != 3) return;
      var token = localStorage.getItem("token");
      api
        .get("/plan/name/" + val, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.plans = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>